import { render, staticRenderFns } from "./swiper-btn-wrap-tertiary.vue?vue&type=template&id=fb873170&scoped=true&"
import script from "./swiper-btn-wrap-tertiary.vue?vue&type=script&lang=js&"
export * from "./swiper-btn-wrap-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb873170",
  null
  
)

export default component.exports